import { Box } from '@mui/material';
import CustomerCardComponent from './customer_card';
import CustomerTableComponent from './customer_table';
import DeleteCustomerModal from './modal/delete_customer';
import EditCustomerModal from './modal/edit_customer';
import { useState } from 'react';

interface CustomerManagementProps {
    view: 'table' | 'card';
    search: string;
    sort: boolean;
}

const CustomerManagementComponent = ({ view, sort, search }: CustomerManagementProps) => {
    const [editing, setEditing] = useState<boolean>(false);
    const [deleting, setDeleting] = useState<boolean>(false);

    return <Box>
        {
            view === 'table'
                ? (<CustomerTableComponent sort={sort} search={search} setEditModal={() => setEditing(true)} setDeleteModal={() => setDeleting(true)} />)
                : (<CustomerCardComponent sort={sort} search={search} setEditModal={() => setEditing(true)} setDeleteModal={() => setDeleting(true)} />)
        }
        {editing && <EditCustomerModal open={editing} onClose={() => setEditing(false)} />}
        {deleting && <DeleteCustomerModal open={deleting} onClose={() => setDeleting(false)} />}
    </Box>;
};

export default CustomerManagementComponent;